import { render, staticRenderFns } from "./osd.vue?vue&type=template&id=3211a7c7&scoped=true"
import script from "./osd.vue?vue&type=script&lang=js"
export * from "./osd.vue?vue&type=script&lang=js"
import style0 from "./osd.vue?vue&type=style&index=0&id=3211a7c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3211a7c7",
  null
  
)

export default component.exports